import { ItemBasicInfo } from './itemsresponse';

export class ItemDetailResponse {
    itemBasicInfo: ItemBasicInfo = new ItemBasicInfo();
    categoryName: string;
    categoryId: number;
    iconData: string;
    iconMime: string;
    description: string;
    serviceFlag: boolean;
    customFields: (CustomFieldInfo)[] | null;
}


export class CustomFieldInfo {
    displayName: string;
    targetFieldName: string;
    value: string;
    dataType: number;
    fieldType: number;
    valueType: number;
    dateFormat: string;
}
